/*
 *  Welcome / Getting Started widget for new users.
 *  Dismiss state is managed by the parent (Dashboard) via props.
 *
 *  Props:
 *  - dismissed: boolean
 *  - onDismiss: function
 *  - onGoToDocs: function
 *  - onGoToWorkspaces: function
 */

import React from 'react';
import { Icon } from 'semantic-ui-react';

const iconStyle = { margin: 0, lineHeight: 1, height: '1em' };

function WelcomeWidget({ dismissed, onDismiss, onGoToDocs, onGoToWorkspaces }) {
  if (dismissed) return null;

  return (
    <div className="workspace-card" style={{ overflow: 'hidden', marginBottom: '24px' }}>
      <div className="workspace-card-accent" style={{ background: '#E61E2A' }} />

      <div style={{ padding: '20px 24px' }}>
        {/* Header row with dismiss */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px' }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: '0 0 6px 0', fontSize: '1.2em', fontWeight: '600', color: 'var(--rmit-blue)' }}>
              <Icon name="hand peace" style={{ ...iconStyle, marginRight: '8px', color: 'var(--rmit-blue)' }} />
              Welcome to RACE
            </h3>
            <p style={{ margin: 0, fontSize: '0.9em', color: '#4b5563', lineHeight: '1.6' }}>
              Get started by reading the documentation, then head to Workspaces to create your first virtual machine.
            </p>
          </div>
          <button
            onClick={onDismiss}
            aria-label="Dismiss welcome message"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              color: '#9ca3af',
              flexShrink: 0,
              lineHeight: 1,
            }}
          >
            <Icon name="close" style={{ ...iconStyle, fontSize: '1.1em' }} />
          </button>
        </div>

        {/* Action buttons */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '16px', flexWrap: 'wrap' }}>
          <button onClick={onGoToDocs} className="workspace-action-btn workspace-action-btn-primary">
            <Icon name="book" style={iconStyle} />
            Read Documentation
          </button>
          <button onClick={onGoToWorkspaces} className="workspace-action-btn workspace-action-btn-secondary">
            <Icon name="plus circle" style={iconStyle} />
            Create Your First Workspace
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeWidget;
